import { isPlatformBrowser, NgForOf, NgIf, SlicePipe } from '@angular/common';
import {Component, ElementRef, HostListener, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, Renderer2, SimpleChanges, ViewChild} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { ClickedOutsideModule } from 'src/app/directives/clicked-outside/clicked-outside.module';
import { AuthenticationHelperService } from 'src/app/services/helpers/authentication-helper.service';
import { ListsHelperService } from 'src/app/services/helpers/lists-helper.service';
import { ItemsHttpService } from 'src/app/services/http-services/items/items-http.service';
import { Column, DeleteModalText, ListItem } from 'src/app/services/http-services/lists/lists-http-intterfaces';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';
import { ConfirmModalComponent } from 'src/app/shared-components/confirm-modal/confirm-modal.component';
import { CopyItemModalComponent } from '../copy-item-modal/copy-item-modal.component';
import { CopyToastNotificationComponent } from 'src/app/shared-components/copy-toast-notification/copy-toast-notification.component';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-item-row',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    ConfirmModalComponent,
    FormsModule,
    RouterModule,
    ClickedOutsideModule,
    SlicePipe,
    CopyItemModalComponent,
    CopyToastNotificationComponent,
    TranslateModule,
    DragDropModule
  ],
  templateUrl: './item-row.component.html',
})
export class ItemRowComponent implements OnChanges, OnInit, OnDestroy {
  @Input() item!: ListItem;
  @Input() addNewRow = false;
  @Input() index: number = 0;
  @Input() isLast = false;
  @Input() columns: Column[] = [];
  isDeleteButtonVisible = false;
  isDeleteModalOpen = false;
  deleteModalText: DeleteModalText = { title: '', description: '', button: '' };
  selectedItem: ListItem | null = null;
  isEditing: { [key: string]: boolean } = {};
  editingValues: { [key: string]: string } = {};
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @Input() user_id: any;
  loggedUser: any;
  isNewItemCreated = false;
  @ViewChild('input') inputElement!: ElementRef;
  currentEditingField: string | null = null;
  isCopyModalOpen = false;
  isCopyDropdownOpen = false;
  url = '';
  isOpenToastOpen = false;
  selectedListAndItem: any;

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: MouseEvent): void {
    if (this.currentEditingField && !this.isClickInsideInput(event)) {
      this.saveEdit(this.currentEditingField);
    }
  }

  constructor(
    private listsHttpService: ListsHttpService,
    private toastService: ToastrService,
    private listsHelperService: ListsHelperService,
    private itemsHttpService: ItemsHttpService,
    private renderer: Renderer2,
    private authenticationHelperService: AuthenticationHelperService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loggedUser = this.authenticationHelperService.getUserData;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.addNewRow !== undefined) {
      this.isNewItemCreated = changes.addNewRow.currentValue;
    }
  }

  openDeleteItemModal(item: ListItem): void {
    this.isDeleteButtonVisible = false;
    this.isDeleteModalOpen = true;
    this.selectedItem = item;
    this.deleteModalText.title = 'ITEMS.delete_item';
    this.deleteModalText.description = 'Are you sure you wish to delete this item? This action cannot be undone.';
    this.deleteModalText.button = 'GENERAL.delete';
  }

  takeAction(): void {
    if (this.selectedItem) {
      this.deleteIetem(this.item?.id);
    }
  }

  deleteIetem(id: number): void {
    this.isDeleteModalOpen = false;
    this.listsHttpService.deleteListItem(id).then((response: any) => {
      this.toastService.success(response.message);
      this.listsHelperService.refreshPage(true);
    });
  }

  getAttributeValue(attributes: any[], lyst_attribute_id: number): string {
    const attribute = attributes.find(attr => attr.lyst_attribute_id === lyst_attribute_id);
    return attribute && attribute.value ? attribute.value : 'Type here...';
  }

  isClickInsideInput(event: MouseEvent): any {
    const target = event.target as HTMLElement;
    return target.tagName === 'INPUT' || target.closest('.column-table-row-item');
  }

  editValue(columnId: string | number, arr: any): void {
    if (this.loggedUser.id !== this.user_id) {
      return;
    }
    if (columnId === 'name') {
      this.isEditing['name'] = true;
      this.editingValues[columnId] = this.item.name;
    } else {
      const attribute = arr.find((attr: any) => attr.lyst_attribute_id === columnId);
      this.isEditing[columnId] = true;
      this.editingValues[columnId] = attribute ? attribute.value : null;
    }
    setTimeout(() => {
      if (this.inputElement) {
        this.renderer.selectRootElement(this.inputElement.nativeElement).focus();
      }
    });
  }

  saveEdit(columnId: number | string): void {
    if (this.loggedUser.id !== this.user_id) {
      return;
    }
    this.isEditing[columnId] = false;
    let reqObj = {};
    if (columnId === 'name') {
      this.item.name = this.editingValues[columnId];
      reqObj = {
        name: this.editingValues[columnId] ? this.editingValues[columnId] : null
      };
    } else {
      reqObj = {
        [`lyst_attribute_${columnId}`]: this.editingValues[columnId] ? this.editingValues[columnId] : null
      };
    }
    this.updateItem(reqObj);
  }

  updateItem(reqObj: any): void {
    this.itemsHttpService.updateItem(this.item.id, reqObj).then((response: any) => {
      this.item = response.data;
      // this.listsHelperService.updateSingleList(true);
    });
  }

  triggerFileInput(event: Event): void {
    if (this.loggedUser.id !== this.user_id) {
      return;
    }
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    const formData = new FormData();
    if (file) {
      formData.append('image', file);
    }
    this.itemsHttpService.addImageToItem(this.item.id, formData).then((response: any) => {
      this.fileInput.nativeElement.value = '';
      if (this.addNewRow) {
        this.addNewRow = false;
      }
      this.item = response.data;
      // this.listsHelperService.updateSingleList(true);
    });
  }

  openCopyModal(selectedItem: ListItem | null, event: any): void {
    this.isCopyDropdownOpen = true;
    event.stopPropagation();
    this.url = `/single-list/${selectedItem?.lyst_id}/0/table`;
    this.selectedItem = selectedItem;
  }

  closeCopyModal(): void {
    this.isOpenToastOpen = false;
  }

  ngOnDestroy(): void {
    // if (this.currentEditingField) {
    //   this.saveEdit(this.currentEditingField);
    //   this.listsHelperService.refreshPage(true);
    // }
  }

}
